module.exports = __webpack_public_path__ + "img/4.fd5098c8.png";